<template>
  <div>
    <div class="flex justify-between">
      <div class="left flex">
        <div class="bars self-center sm:mr-4 md:mr-8 lg:hidden">
          <i class="fa fa-bars fa-2x cursor-pointer" @click="toggleSideBar" />
        </div>
        <Logo />
      </div>
      <div class="right flex items-center">
        <!-- <div class="mx-2 self-center">
          help
        </div> -->

        <div class="mr-4 md:mr-8 self-center">
          <pt-dropdown ref="notiDropdown">
            <i
              slot="button"
              class="icon-ic icon-ic-notification text-2xl"
              aria-hidden="true"
              @click="toggleNotiDropdown"
            />
            <a
              v-for="(notification, index) in notifications"
              :key="index"
              role="menuitem"
              class="pt-dropdown-item noti"
            ><i class="icon-ic icon-ic-accepted" /> <span class="pl-2">{{ notification.body }}</span> </a>
            <router-link to="notifications" class="pl-4 block no-underline text-bold text-grey-dark">See all</router-link>
          </pt-dropdown>
        </div>
        <pt-dropdown ref="dropdown">
          <div slot="button" @click="toggleDropdown">
            <div class="flex items-center sm:ml-2">
              <img
                :src="userAvatar"
                class="w-10 h-10 rounded-sm mr-4"
                alt="avatar"
              />
              <div class="user hidden lg:block">
                <p class="user-name">{{ auth.user.name }} <i class="fa fa-caret-down" /></p>
              </div>
            </div>
          </div>
          <a
            role="menuitem"
            class="pt-dropdown-item cursor-pointer"
            @click="toResetPassword"
          > Reset Password</a>
          <a
            role="menuitem"
            class="pt-dropdown-item cursor-pointer"
            @click="handleLogout"
          > Logout</a>
        </pt-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Logo from './Logo';
import config from '../../config';
import { PtDropdown, PtDropdownItem } from '@pathao/ui-components/esm/Dropdown';

export default {
  name: 'TopBar',
  components: {
    Logo,
    PtDropdown,
    PtDropdownItem,
  },
  data() {
    return {
      imageURL: '',
      notifications: [],
      newNotificationCounter: 0,
    };
  },
  computed: {
    ...mapState(['auth']),
    ...mapGetters({
      notyObj: 'app/getNotyObj',
      userName: 'auth/userName',
      orders: 'app/getOrderObj',
    }),
    userAvatar() {
      if (this.auth.user.profile_pic) {
        return config.api.imageURL + this.auth.user.profile_pic;
      }
      return '/img/default-user.3c1dd009.png';
    },
  },
  watch: {
    notyObj: function(newValue, oldValue) {
      this.notifications = cloneDeep(newValue);
    },
    orders(newValue) {
      this.notifyResto(newValue[0]);
    },
  },
  methods: {
    notifyResto(order) {
      let message = '';

      switch (order.status) {
        case 'PENDING':
          message = 'A New Order Is In Pending State. Please Check Your Order.';
          break;
        case 'PLACED':
          // this.placedOrders.push(order);
          // push = {
          //   restaurant_name: this.auth.user.restuarant_name, // localStorage.getItem('restuarant_name'),
          //   order_id: order.tracking_id,
          // };
          // this.CleavertapService.eventPush('order placed', push);
          message = 'Order ID ' + order.tracking_id + ' has been received.';
          break;
        case 'ACCEPTED':
          message = 'Order ID ' + order.tracking_id + ' Has Been Accepted.';
          break;
        case 'CANCELED':
          message = 'Order ID ' + order.tracking_id + ' Has Been Canceled.';
          break;
        case 'HANDOVER':
          message = 'Order ID ' + order.tracking_id + ' Has Been Handedover.';
          break;
        case 'DELIVERED':
          // push = {
          //   restaurant_name: this.auth.user.restuarant_name,
          //   order_id: order.tracking_id,
          // };
          // this.CleavertapService.eventPush('delivered', push);
          message = 'Order ID ' + order.tracking_id + ' Has Been Delivered!';
          break;
        default:
          break;
      }

      console.log(message);

      if (message) {
        this.$notification.success(message);
        const title = 'ORDER ' + order.status;
        const obj = {
          title: title,
          body: message,
          type: 'info',
          order: order,
        };

        console.log(obj);
        this.notifications.unshift(obj);
      }
    },
    toResetPassword() {
      this.$router.push({ name: 'reset-pass' });
    },
    toggleSideBar() {
      this.$bus.$emit('toggle-sidebar');
    },
    toggleDropdown() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.toggle();
      }
    },
    toggleNotiDropdown() {
      if (this.$refs.notiDropdown) {
        this.$refs.notiDropdown.toggle();
        this.$sendEvent('RS_NotificationList');
      }
    },
    handleLogout() {
      this.updateIsChain(null);
      this.updateOrderAcceptingStatus(null);
      this.$sendEvent('RS_Logout');

      this.logOut()
        .then(() => {
          this.$router.replace({ name: 'login' });
        });
    },
    ...mapActions({
      logOut: 'auth/logOut',
      updateIsChain: 'app/updateIsChain',
      updateOrderAcceptingStatus: 'app/updateOrderAcceptingStatus',
    }),
  },
};

</script>

<style>
  .user .user-name {
    font-size: 17px;
    color: #000000;
  }
  .user .user-meta {
    opacity: 0.4;
    font-size: 13px;
    color: #000000;
    width: 140px;
  }
  .pt-dropdown {
    cursor: pointer;
  }
  .pt-dropdown-item.noti {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #DDD;
  }
  /*.pt-dropdown-item.noti .see-all {
    margin-top: 15px;
  }*/
  .pt-dropdown-item {
    font-size: 14px;
    color: #152934;
    text-align: left;
    font-weight: normal;
    padding-bottom: .7rem;
    padding-top: .7rem;
  }
  .pt-dropdown-item i.fa {
    padding-right: 10px
  }
  .pt-dropdown-item:hover {
    background: #F5F6F7;
    font-size: 14px;
    color: #152934;
    text-align: left;
    line-height: 20px;
    font-weight: 600;
    cursor: pointer;
  }
</style>
